module.exports = "/assets/bees-offline.png";